module.exports = __webpack_public_path__ + "img/yyzz.89b2c0fc.png";